(function () {
	function swiperInit() {
		subSliderInit(true);
		sliderInit(true);
	}

	document.addEventListener("shopify:section:load", function (e) {
		swiperInit();
	});

	let resizeTimer;
	window.addEventListener("resize", function () {
		clearTimeout(resizeTimer);
		resizeTimer = setTimeout(function () {
			$(".product-section .js-media-list").each(function () {
				if (this.swiper) this.swiper.destroy();
			});
			$(".product-section .js-media-sublist").each(function () {
				if (this.swiper) this.swiper.destroy();
			});

			swiperInit();
		}, 200);
	});

	swiperInit();
})();
